import AppState from './app/state';
import FormsState from './forms/state';
import LocaleState from './locale/state';
import ThemeState from './theme/state';
import UserState from './user/state';
import RoutesState from './routes/state';
import NotificationsState from './notifications/state';
import NavigationState from './navigation/state';
import ModelConfigsState from './model-configs/state';
import OrderProductFilesState from './order-product-files/state';
import ServicesState from './services/state';
import FeaturesState from './features/state';
import {state as WorkdayState} from './workday';
import {state as ChatsState} from './chats';
import {state as ArticlesState} from './articles';
import {IReduxStoreState} from '../@interfaces';

const initialState: IReduxStoreState = {
    app: AppState,
    forms: FormsState,
    locale: LocaleState,
    theme: ThemeState,
    user: UserState,
    routes: RoutesState,
    notifications: NotificationsState,
    navigation: NavigationState,
    modelConfigs: ModelConfigsState,
    orderProductFiles: OrderProductFilesState,
    services: ServicesState,
    features: FeaturesState,
    workday: WorkdayState,
    chats: ChatsState,
    articles: ArticlesState,
};

export default initialState;
